import { useEffect } from 'react';

import type { ReactNode, RefObject } from 'react';
import { hasStorageAvailable } from '@klv/shared/utils/storage';

export const ScrollToError = ({ children, innerRef }: { children: ReactNode; innerRef: RefObject<HTMLDivElement>; }) => {
  const errorRef = innerRef;
  useEffect(() => {
    if (errorRef && errorRef.current) {
      errorRef.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });

  return <div ref={errorRef}>{children}</div>;
};

export const getNumMarketingFields = (initialValuesObject: object) => {
  const marketingFields = Object.keys(initialValuesObject).filter((key) => key.startsWith('field_'));
  const fieldNumbers = marketingFields.map((field) => Number(field.replace('field_', ''))).sort((a, b) => a - b);

  return fieldNumbers?.[fieldNumbers.length - 1];
};

export const getSessionStorageValues = () => {
  if (hasStorageAvailable('sessionStorage') && sessionStorage.getItem('formValues')) {
    const formValues = JSON.parse(sessionStorage.getItem('formValues') || '{}');
    return {
      email: formValues.email || '',
      full_name: formValues.full_name || '',
      field_6: '',
      field_9: '',
      field_10: true,
      field_14: '',
      company_website: formValues.company_website || formValues.company_url || '',
      company_url: formValues.company_url || formValues.company_website || '',
      company: formValues.company || '',
      phone: formValues.phone || '',
    };
  }
  return {
    email: '',
    full_name: '',
    field_6: '',
    field_9: '',
    field_10: true,
    field_14: '',
    company_website: '',
    company_url: '',
    company: '',
    phone: '',
  };
};
